import { Path, Shape } from "three";
import {
	type ThreeInputLinesType,
	ThreeShapeSideTypes,
	type ThreeSidePathsType,
} from "../../../../../types/three";
import type { DimensionProperties } from "../../../../../types/workpiece";
import Rectangle from "../Rectangle";

export default class Custom extends Rectangle {
	public static code = "plate_rectangle_custom";

	public getThreeShape(props: DimensionProperties["plate_rectangle_custom"]) {
		const [length, width] = [props.length / 1000, props.width / 1000];

		return new Shape()
			.moveTo(0, 0)
			.lineTo(length, 0)
			.lineTo(length, width)
			.lineTo(0, width)
			.lineTo(0, 0);
	}

	public getThreeSidePaths(
		props: DimensionProperties["plate_rectangle_custom"],
	): ThreeSidePathsType[] {
		const [length, width] = [props.length / 1000, props.width / 1000];

		return [
			{
				path: new Path().moveTo(0, 0).lineTo(length, 0),
				code: "length2",
				type: ThreeShapeSideTypes.side,
			},
			{
				path: new Path().moveTo(length, 0).lineTo(length, width),
				code: "width2",
				type: ThreeShapeSideTypes.side,
			},
			{
				path: new Path().moveTo(length, width).lineTo(0, width),
				code: "length1",
				type: ThreeShapeSideTypes.side,
			},
			{
				path: new Path().moveTo(0, width).lineTo(0, 0),
				code: "width1",
				type: ThreeShapeSideTypes.side,
			},
		];
	}

	public getThreeInputLines(
		props: DimensionProperties["plate_rectangle_custom"],
	): ThreeInputLinesType[] {
		const [length, width] = [props.length / 1000, props.width / 1000];

		return [
			{
				dimension: props.length,
				path: new Path().moveTo(0, 0).lineTo(length, 0),
				type: ThreeShapeSideTypes.side,
				code: "length",
			},
			{
				dimension: props.width,
				path: new Path().moveTo(0, 0).lineTo(0, width),
				type: ThreeShapeSideTypes.side,
				code: "width",
			},
		];
	}

	public getDimensions(props: DimensionProperties["plate_rectangle_custom"]) {
		return {
			width: props.width ? props.width : 1000,
			length: props.length ? props.length : 2000,
		};
	}
}
